/*
 * Action Types
 */
export enum TransportOperatorsTypes {
  LIST_TRANSPORT_OPERATORS_REQUEST = '@transportOperators/LIST_TRANSPORT_OPERATORS_REQUEST',
  LIST_TRANSPORT_OPERATORS_SUCCESS = '@transportOperators/LIST_TRANSPORT_OPERATORS_SUCCESS',
  LIST_TRANSPORT_OPERATORS_FAILURE = '@transportOperators/LIST_TRANSPORT_OPERATORS_FAILURE',

  SELECT_TRANSPORT_OPERATOR_REQUEST = '@transportOperators/SELECT_TRANSPORT_OPERATOR_REQUEST',
  SELECT_TRANSPORT_OPERATOR_SUCCESS = '@transportOperators/SELECT_TRANSPORT_OPERATOR_SUCCESS',
  SELECT_TRANSPORT_OPERATOR_FAILURE = '@transportOperators/SELECT_TRANSPORT_OPERATOR_FAILURE',

  UPDATE_TRANSPORT_OPERATOR_REQUEST = '@transportOperators/UPDATE_TRANSPORT_OPERATOR_REQUEST',
  UPDATE_TRANSPORT_OPERATOR_SUCCESS = '@transportOperators/UPDATE_TRANSPORT_OPERATOR_SUCCESS',
  UPDATE_TRANSPORT_OPERATOR_FAILURE = '@transportOperators/UPDATE_TRANSPORT_OPERATOR_FAILURE',

  OPERATOR_ACCESS_REQUEST = '@transportOperators/OPERATOR_ACCESS_REQUEST',
  OPERATOR_ACCESS_SUCCESS = '@transportOperators/OPERATOR_ACCESS_SUCCESS',
  OPERATOR_ACCESS_FAILURE = '@transportOperators/OPERATOR_ACCESS_FAILURE',
}

/*
 * Data types
 */
export interface TransportOperatorInterface {
  id: string;
  name: string;
  cnpj: string;
  createdAt?: string | null;
  updatedAt?: string | null;
  photoUrl?: string | null;
  type: number;
  SellingPointTransportOperator?: {
    id: string;
    transactionMethods: string[];
    operationMethods?: string[];
    createdAt: string;
    updatedAt: string;
    sellingPointId: string;
    transportOperatorId: string;
    partialPayment?: boolean;
    allowedAmount?: number;
  };
  SupervisorOperator: {
    id: string;
    modules: string;
    levels: string;
    supervisorId: string;
    operatorId: string;
    createdAt?: string | null;
    updatedAt?: string | null;
  };
  Address?: {
    id?: string;
    cep?: string;
    street?: string;
    number?: string;
    compl?: string;
    neigh?: string;
    city?: string;
    state?: string;
    latitude?: string;
    longitude?: string;
    codeIBGE?: any;
    createdAt?: string;
    updatedAt?: string;
  };
}

/*
 * State type
 */
export interface TransportOperatorsState {
  readonly transportOperatorsList: TransportOperatorInterface[];
  readonly transportOperatorData: TransportOperatorInterface;
  readonly transportOperatorSelected: TransportOperatorInterface;
  readonly loading: boolean;
  readonly error: boolean;
}
